import { render, staticRenderFns } from "./InvoiceNew_Items_List.vue?vue&type=template&id=6f9e3d2d&"
import script from "./InvoiceNew_Items_List.vue?vue&type=script&lang=js&"
export * from "./InvoiceNew_Items_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports